<template>
  <div class="home-container">
    <div
      v-infinite-scroll="load"
      class="video-grid-container"
      :infinite-scroll-disabled="disabled"
      :infinite-scroll-distance="200"
      :infinite-scroll-immediate="false"
    >
      <el-row class="video-row">
        <el-col
          v-for="(item, index) in dataList"
          :key="'video-'+index"
          :xs="12"
          :sm="8"
          :md="6"
          :lg="4"
          class="video-card-col"
        >
          <video-card :video="item" />
        </el-col>
      </el-row>

      <div class="load-status">
        <div v-if="loading" class="loading-bar">
          <i class="el-icon-loading" /> <span>加载中...</span>
        </div>
        <div v-if="noMore" class="no-more-bar">
          <span class="dot" /> 到底啦 <span class="dot" />
        </div>
        <div v-if="isError" class="error-bar" style="text-align: center; padding: 15px; color: #909399;">
          <span>加载失败，请检查网络 </span>
          <el-button type="text" icon="el-icon-refresh" @click="retryLoad">点击重试</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VideoCard from '@/components/card/VideoCard'
import { getBannerVideo, videoRecommend } from '@/api/vod'

export default {
  name: 'Home',
  components: { VideoCard },
  data() {
    return {
      nextId: 0,
      dataList: [],
      loading: false,
      noMore: false,
      isError: false,
      isFirstLoading: true,
      carouselList: [],
      carouselHeight: '340px',
      timer: null
    }
  },
  computed: {
    disabled() {
      return this.loading || this.noMore || this.isFirstLoading || this.isError
    }
  },
  created() {
    this.handleResize()
    this.initData()
  },
  mounted() {
    window.addEventListener('resize', this.debounceResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.debounceResize)
  },
  methods: {
    debounceResize() {
      if (this.timer) clearTimeout(this.timer)
      this.timer = setTimeout(() => this.handleResize(), 200)
    },
    handleResize() {
      const width = window.innerWidth || document.documentElement.clientWidth
      if (width < 992) {
        this.carouselHeight = width < 768 ? '190px' : '230px'
      } else {
        this.carouselHeight = '340px'
      }
    },
    async initData() {
      try {
        await Promise.all([
          this.getHotVideoWrapper(),
          this.videoRecommendWrapper(this.nextId)
        ])
      } finally {
        this.isFirstLoading = false
      }
    },
    async videoRecommendWrapper(nextId) {
      if (this.noMore || this.isError) return
      this.loading = true
      try {
        const resp = await videoRecommend(nextId)
        if (resp.code === 0) {
          const respData = resp.data
          if (!respData || respData.length === 0) {
            this.noMore = true
          } else {
            this.dataList = [...this.dataList, ...respData]
            this.nextId++
          }
        } else {
          this.isError = true // 标记错误
        }
      } catch (e) {
        console.error(e)
        this.isError = true // 标记错误
      } finally {
        setTimeout(() => { this.loading = false }, 400)
      }
    },
    retryLoad() {
      this.isError = false
      this.load()
    },
    load() {
      this.videoRecommendWrapper(this.nextId)
    },
    async getHotVideoWrapper() {
      const resp = await getBannerVideo()
      if (resp.code === 0) this.carouselList = resp.data
    }
  }
}
</script>

<style lang="scss" scoped>
.home-container {
  padding: 15px 20px;
  max-width: 1700px;
  margin: 0 auto;
  box-sizing: border-box;
}

/* 推荐位布局：PC端强制对齐的关键 */
.top-recommend-row {
  display: flex !important;
  flex-wrap: wrap;
  align-items: stretch; /* 关键：让子项高度一致 */
  margin: 0 !important;
  margin-bottom: 25px !important;

  .el-col {
    padding: 0 8px !important;
    margin-bottom: 15px;
  }
}

/* 包裹容器，确保高度撑满 col */
.carousel-full-height-container {
  height: 100%;
  width: 100%;
}

.custom-carousel {
  width: 100%;
  height: 100%;
  border-radius: 12px;
  overflow: hidden;
  background: #f0f0f0;
  // 必须穿透设置 container 为 100%
  ::v-deep .el-carousel__container { height: 100% !important; }
}

.carousel-placeholder {
  width: 100%;
  background: #f5f7fa;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #c0c4cc;
}

.carousel-item-wrapper {
  width: 100%; height: 100%; position: relative;
  .carousel-img { width: 100%; height: 100%; object-fit: cover; }
  .carousel-mask {
    position: absolute; bottom: 0; width: 100%; height: 45%;
    background: linear-gradient(to top, rgba(0,0,0,0.8), transparent);
  }
  .carousel-info {
    position: absolute; bottom: 15px; left: 15px; color: #fff;
    .carousel-title { font-size: 17px; font-weight: 500; margin: 0; }
  }
}

.video-row {
  margin: 0 !important;
  display: flex;
  flex-wrap: wrap;
  .el-col {
    padding: 0 8px !important;
    margin-bottom: 20px;
  }
}

.load-status {
  text-align: center;
  padding: 40px 0;
  color: #909399;
}

/* 响应式断点 */
@media screen and (min-width: 992px) {
  .top-recommend-row {
    height: 340px;
  }
  .carousel-col, .notice-col {
    height: 100%; /* 确保 Col 也是 100% */
  }
  .equal-height-component {
    height: 100% !important;
  }
}

@media screen and (max-width: 991px) {
  .home-container { padding: 10px; }
  .top-recommend-row { height: auto !important; }
  .carousel-col {
    height: 190px !important;
    ::v-deep .el-carousel__container { height: 190px !important; }
  }
}

body { overflow-x: hidden; }
.shadow-hover { transition: all 0.3s; &:hover { box-shadow: 0 10px 25px rgba(0,0,0,0.1); } }
</style>
